module.exports = __webpack_public_path__ + "img/chico.96f0e284.jpg";